/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useSimpleNotifyModalStyles = makeStyles({
  modalText: {
    padding: '40px 20px 15px',
    textAlign: 'center',
  },
});
